import { request } from "../../../../../../utils/APIRequestService";
import {HttpRequest} from "../../../../../../enums/http.methods";

const ADD_NEW_DEPLOYMENT_JOB = "/add_deployment_job";
const GET_ONE_DEPLOYMENT_JOB = "/get_deployment_job_by_id";
// const GET_ALL_DEPLOYMENT_JOBS = "/get_deployment_jobs";
const GET_RTSP_DEPLOYED_JOBS_FOR_SUPERUSER = "/get_rtsp_deployed_jobs_for_superuser";
const GET_RTSP_DEPLOYMENT_JOBS_FOR_SUPERUSER = "/get_rtsp_deployment_jobs_for_superuser";
const START_DEPLOYMENT_JOB = "/start_deployment";
// export async function getAllDeploymentJobsDetails() {
//   return await request({
//     endpoint: GET_ALL_DEPLOYMENT_JOBS,
//     method: "GET",
//   });
// }

export async function getAllDeployedJobsDetails(company_id) {
  return await request({
    endpoint: GET_RTSP_DEPLOYED_JOBS_FOR_SUPERUSER +'?company_id=' +company_id,
    method: HttpRequest.GET
  });
}

export async function getAllDeploymentJobsDetails(company_id) {
  return await request({
    endpoint: GET_RTSP_DEPLOYMENT_JOBS_FOR_SUPERUSER +'?company_id=' +company_id,
    method: HttpRequest.GET
  });
}


export async function getDeploymentJobDetailsById(id) {
  return await request({
    endpoint: GET_ONE_DEPLOYMENT_JOB + "?deployment_job_id=" + id,
    method: "GET",
  });
}

export async function addNewDeploymentJobsDetails(data) {
  return await request({
    endpoint: ADD_NEW_DEPLOYMENT_JOB,
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function startDeploymentJob(id) {
  return await request({
    endpoint: START_DEPLOYMENT_JOB + "?deployment_job_id=" + id,
    method: "POST",
  });
}
